import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServicePT() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Voltar ao App
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Termos de Serviço</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Última atualização: {new Date().toLocaleDateString()}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Informações da Empresa</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Simple Stickers é operado por <span className="font-semibold">Puretech s.r.o.</span>,
                  uma <span className="font-semibold">sociedade de responsabilidade limitada</span> constituída de acordo com as leis da <span className="font-semibold">República Tcheca</span>.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-700 mb-2">Detalhes da Empresa:</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>Número de Identificação (IČO):</strong> 05503795</li>
                    <li><strong>Situação do IVA:</strong> Não contribuinte</li>
                    <li><strong>Endereço:</strong> Heydukova 1035, 54401 Dvůr Králové nad Labem, Czechia</li>
                    <li><strong>E-mail:</strong> support@simplestickers.app</li>
                    <li><strong>Site:</strong> <a href="https://www.simplestickers.app" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 hover:underline">www.simplestickers.app</a></li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Aceitação dos Termos</h2>
              <p className="leading-relaxed">
                Ao acessar e usar o Simple Stickers ("o Serviço"), você aceita e concorda em estar vinculado aos termos e disposições deste contrato. Se você não concordar em cumprir o acima exposto, por favor, não use este serviço.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Descrição do Serviço</h2>
              <p className="leading-relaxed">
                Simple Stickers é um aplicativo de gerenciamento de tarefas e projetos que fornece aos usuários ferramentas para organizar notas adesivas usando um sistema de quadro estilo Kanban. O serviço inclui níveis gratuitos e premium com diferentes conjuntos de recursos e limites de uso.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Contas de Usuário</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Você é responsável por manter a confidencialidade de sua conta e senha e por restringir o acesso ao seu computador. Você concorda em aceitar a responsabilidade por todas as atividades que ocorrem em sua conta ou senha.
                </p>
                <p className="leading-relaxed">
                  Você deve fornecer informações precisas e completas ao criar sua conta e manter essas informações atualizadas.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Termos de Assinatura e Pagamento</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Plano Gratuito:</strong> Inclui acesso a recursos básicos com limitações no número de notas adesivas (50) e sugestões de IA (10 por dia).
                </p>
                <p className="leading-relaxed">
                  <strong>Plano Premium:</strong> Disponível por $48 por ano, inclui limites aumentados (1000 notas adesivas, 100 sugestões de IA por dia) e recursos adicionais como capacidades de compartilhamento de notas adesivas.
                </p>
                <p className="leading-relaxed">
                  O processamento de pagamentos é realizado pelo Polar. As assinaturas são renovadas automaticamente, a menos que sejam canceladas. Você pode cancelar sua assinatura a qualquer momento através das configurações da sua conta.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Uso Aceitável</h2>
              <p className="leading-relaxed">
                Você concorda em não usar o serviço para armazenar, transmitir ou distribuir conteúdo que seja ilegal, prejudicial, ameaçador, abusivo, assediador, difamatório, vulgar, obsceno ou de outra forma censurável. Você também concorda em não interferir no serviço ou tentar acessar contas pertencentes a outros.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Privacidade e Proteção de Dados Pessoais</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Sua privacidade é importante para nós. Para detalhes sobre como coletamos, usamos e protegemos suas informações pessoais, consulte nossa <a href="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium">Política de Privacidade</a>.
                </p>
                <p className="leading-relaxed">
                  Ao usar este serviço, você também concorda com nossa Política de Privacidade e com o processamento de seus dados pessoais de acordo com o GDPR e as leis de proteção de dados aplicáveis.
                </p>
                <p className="leading-relaxed">
                  Para exercer seus direitos sob o GDPR ou para consultas sobre proteção de dados, entre em contato conosco em <strong>support@simplestickers.app</strong>.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Disponibilidade do Serviço e Suporte</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Disponibilidade do Serviço:</strong> Nos esforçamos para máxima disponibilidade do serviço e operação confiável. Em caso de interrupções não planejadas, trabalhamos para resolvê-las prontamente. O serviço é fornecido "como está" sem garantias formais de disponibilidade.
                </p>
                <p className="leading-relaxed">
                  <strong>Manutenção:</strong> Para garantir segurança e estabilidade, podemos realizar manutenção contínua do serviço. Pretendemos agendar manutenções planejadas durante períodos de baixo uso e fornecer aviso prévio sempre que possível. Em casos urgentes (por exemplo, patches de segurança), a manutenção pode ocorrer sem aviso prévio.
                </p>
                <p className="leading-relaxed">
                  <strong>Suporte:</strong> Oferecemos suporte técnico por e-mail em support@simplestickers.app. Nos esforçamos para responder o mais rápido possível, porém tempos de resposta específicos não são garantidos.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Política de Reembolso</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Garantia de Devolução do Dinheiro em 30 Dias:</strong> Se você não estiver satisfeito com o serviço premium, pode solicitar um reembolso total dentro de 30 dias da sua compra inicial. Após 30 dias, todos os pagamentos são finais e não reembolsáveis.
                </p>
                <p className="leading-relaxed">
                  <strong>Erros de Cobrança:</strong> Se você acredita que foi cobrado incorretamente, entre em contato conosco em support@simplestickers.app dentro de 30 dias da cobrança.
                </p>
                <p className="leading-relaxed">
                  <strong>Processamento de Reembolso:</strong> Reembolsos aprovados serão processados dentro de 10-14 dias úteis para o método de pagamento original. Reservamo-nos o direito de aprovar ou negar solicitações de reembolso a nosso exclusivo critério.
                </p>
                <p className="text-sm text-gray-600">
                  Nota: Cancelamentos de assinatura não resultam automaticamente em reembolsos. Você deve solicitar explicitamente um reembolso dentro do período de 30 dias.
                </p>
              </div>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Restrições de Idade e Elegibilidade</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Idade Mínima:</strong> Você deve ter pelo menos 16 anos para usar este serviço.
                </p>
                <p className="leading-relaxed">
                  <strong>Consentimento Parental:</strong> Usuários menores de 18 anos devem ter consentimento dos pais ou responsáveis para usar o serviço.
                </p>
                <p className="leading-relaxed">
                  <strong>Usuários Empresariais:</strong> Contas empresariais exigem que o usuário tenha autoridade para vincular a organização.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Lei Aplicável e Jurisdição</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Estes Termos serão regidos e interpretados de acordo com as leis da República Tcheca, sem considerar suas disposições sobre conflitos de leis.
                </p>
                <p className="leading-relaxed">
                  Quaisquer disputas decorrentes destes Termos ou do seu uso do Serviço estarão sujeitas à jurisdição exclusiva dos tribunais da República Tcheca.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Moderação de Conteúdo</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Reservamo-nos o direito de remover, modificar ou recusar a exibição de qualquer conteúdo que viole estes Termos ou que consideremos inapropriado, a nosso exclusivo critério.
                </p>
                <p className="leading-relaxed">
                  Se você acredita que algum conteúdo deve ser revisado, entre em contato conosco em support@simplestickers.app.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Propriedade Intelectual</h2>
              <p className="leading-relaxed">
                O serviço e seu conteúdo original, recursos e funcionalidades são de propriedade do Simple Stickers e são protegidos por leis internacionais de direitos autorais, marcas registradas, patentes, segredos comerciais e outras leis de propriedade intelectual.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Limitação de Responsabilidade</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Na máxima extensão permitida pela lei aplicável, o Simple Stickers não será responsável por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos, incluindo, sem limitação, perda de lucros, dados, uso, boa vontade ou outras perdas intangíveis, resultantes do seu uso do serviço.
                </p>
                <p className="leading-relaxed">
                  Esta limitação de responsabilidade não se aplica a danos causados por conduta dolosa ou negligência grave, ou conforme proibido pela lei aplicável.
                </p>
                <p className="leading-relaxed">
                  Nossa responsabilidade total perante você por quaisquer reclamações decorrentes do seu uso do serviço não excederá o valor que você nos pagou nos 12 meses anteriores à reclamação, ou €100, o que for maior.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Rescisão</h2>
              <p className="leading-relaxed">
                Podemos encerrar ou suspender sua conta e proibir o acesso ao serviço imediatamente, sem aviso prévio ou responsabilidade, a nosso exclusivo critério, por qualquer motivo, incluindo, sem limitação, se você violar os Termos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Alterações nos Termos</h2>
              <p className="leading-relaxed">
                Reservamo-nos o direito de modificar ou substituir estes Termos a qualquer momento. Se uma revisão for material, forneceremos pelo menos 30 dias de aviso antes que quaisquer novos termos entrem em vigor.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Informações de Contato</h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato conosco:
                </p>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-700">
                    <strong>E-mail:</strong> support@simplestickers.app
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    Para todas as consultas sobre suporte, questões legais, privacidade, proteção de dados e questões comerciais
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
